import CryptoJS from 'crypto-js';

/**
 * CryptoHelperService is a service class that provides encryption and decryption functionalities.
 * It uses AES encryption provided by the CryptoJS library.
 */
class CryptoHelperService {
    /**
     * Constructs a new instance of CryptoHelperService.
     * @param {Object} $routeParams - AngularJS $routeParams service.
     * @param {Object} $http - AngularJS $http service.
     * @param {Object} $rootScope - AngularJS $rootScope service.
     * @param {Object} $q - AngularJS $q service for promises.
     */
    constructor($routeParams, $http, $rootScope, $q) {
        this.$routeParams = $routeParams;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.cryptoKey = 'test'; // Default encryption key
    }

    /**
     * Sets the encryption key for the service.
     * @param {string} value - The new encryption key.
     */
    setCryptographyKey(value) {
        this.cryptoKey = value;
    }

    /**
     * Retrieves the current encryption key.
     * @returns {string} The current encryption key.
     */
    getCryptoKey() {
        return this.cryptoKey;
    }

    /**
     * Encrypts a message using AES encryption.
     * @param {string} message - The message to encrypt.
     * @param {string} [key] - The encryption key. If not provided, the default key is used.
     * @returns {string} The encrypted message.
     */
    encrypt(message, key) {
        if (key === undefined) {
            key = this.cryptoKey;
        }
        return CryptoJS.AES.encrypt(message, key).toString();
    }

    /**
     * Decrypts an encrypted message using AES decryption.
     * @param {string} encryptedData - The encrypted message to decrypt.
     * @param {string} [key] - The decryption key. If not provided, the default key is used.
     * @returns {string|boolean} The decrypted message or false if decryption fails.
     */
    decrypt(encryptedData, key) {
        if (key === undefined) {
            key = this.cryptoKey;
        }

        /**
         * Checks if the text is JSON and handles UTF-8 encoding.
         * @param {string} text - The text to check.
         * @returns {string} The processed text.
         */
        const isJson = (text) => {
            let utf8Text = text;
            try {
                utf8Text = decodeURIComponent(escape(text));
            } catch (e) {
                console.log('Text is UTF-8 ==>', e.message); // URI malformed
            }
            return utf8Text;
        };

        const decrypted = CryptoJS.AES.decrypt(isJson(encryptedData), key).toString(CryptoJS.enc.Utf8);
        return decrypted ? decrypted : false;
    }
}

export default CryptoHelperService;